<template lang="jade" src="../_partials/button.jade"></template>
<script>
  import _ from 'lodash'
  import buttons from '../_shared/traits'

  export default {
    data: () => ({}),
    mixins: [buttons],
    computed: {
      disabled () {
        let errors = _.filter(this.notifications, ['type', 'error'])
        return errors.length > 0
      }
    }
  }
</script>



// WEBPACK FOOTER //
// submit.vue?6ec3aeb8